<template>
  <div class="custom-tree-container">
    <div class="block">
      <el-divider content-position="left">代理树</el-divider>
      <el-tree :props="props" :load="loadNode" lazy>
        <template slot-scope="{ node, data }">
          <div>
            <span>{{ data.real_name }}({{ data.level_name }})</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ data.mobile }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ data.idcard_no }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ data.auth_code }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="el-tag el-tag--success">{{ data.status_text }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ data.created_at }}</span>
            <el-divider direction="vertical"></el-divider>
            <router-link tag="a" target="_blank" :to="'/users/' + data.id + '/edit'"><el-button type="text" size="small">查看详情</el-button></router-link>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { getChildren } from '@/api/users';

export default {
  name: 'UserAgentTree',
  props: {
    data: Object
  },
  data() {
    return {
      props: {
        label: 'real_name',
        children: 'zones',
        isLeaf: 'leaf'
      }
    };
  },
  methods: {
    async loadNode(node, resolve) {
      console.log(node.data, node, resolve);
      let id = 0;
      let data;

      if (node.level === 0) {
        id = this.$route.params['id'];
      } else {
        id = node.data.id;
      }

      ({ data } = await getChildren(id, { type: 0 }));
      console.log(data);

      return resolve(data);
    }
  }
};
</script>

<style scoped lang="scss">
/* //设置容器的样式 */
.down-tree {
  flex: 1; /* //父元素采用flex布局 */
  max-width: 200px; /* //设置最小宽度 */
  height: 678px;
  background: rgba(245, 248, 250, 1);
  border-radius: 3px;
  border: 1px solid rgba(211, 219, 222, 1);
  margin-left: 12px;
  padding: 14px;
  /* //设置滚动条高度，隐藏横向滚动条 */
  ::v-deep .el-scrollbar {
    height: 578px;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>
